import React, { useState } from 'react';
import MapaUbicacion from '../components/Inicio/MapaUbicacion';
import FormularioContacto from '../components/Contacto/FormularioContacto';
import Areas from '../components/Contacto/Areas';
import Swal from 'sweetalert2';
import clienteAxios from '../helpers/axios.helper';

function Contacto() {
  const [formData, setFormData] = useState({
    email: '',
    motivo: '',
    nombre: '',
    codArea: '',
    telefono: '',
    mensaje: ''
  });

  const [isSending, setIsSending] = useState(false); // Para saber si se está enviando

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    const { email, motivo, nombre, codArea, telefono, mensaje } = formData;

    if (!email || !motivo || !nombre || !codArea || !telefono || !mensaje) {
      alert("Todos los campos son obligatorios.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Por favor, ingrese un email válido.");
      return false;
    }

    if (isNaN(codArea) || isNaN(telefono)) {
      alert("El código de área y el teléfono deben ser números.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSending(true); // Indicamos que estamos enviando el mensaje

    // Mostrar el mensaje de "Enviando..." con SweetAlert
    Swal.fire({
      title: 'Enviando...',
      text: 'Por favor espera mientras enviamos tu consulta.',
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await clienteAxios.post('/email/enviar', {
        type: 'consulta',
        data: formData
      });

      if (response.status === 200) {
        Swal.fire('¡Éxito!', 'Consulta enviada con éxito.', 'success');
        setFormData({
          email: '',
          motivo: '',
          nombre: '',
          codArea: '',
          telefono: '',
          mensaje: ''
        });
      }
    } catch (error) {
      console.error("Error en el envío:", error);
      if (error.response) {
        // Errores desde el servidor
        Swal.fire('Error', `Error al enviar la consulta: ${error.response.data.message || 'Intente nuevamente más tarde.'}`, 'error');
      } else {
        // Otros errores (e.g., red)
        Swal.fire('Error', 'Hubo un error al enviar la consulta. Intente nuevamente más tarde.', 'error');
      }
    } finally {
      setIsSending(false); // Indicamos que ya no se está enviando
    }
  };

  return (
    <div className="min-h-screen p-8 bg-gray-100">
      <h2 className="text-3xl font-bold text-center mb-6">¡Comunícate con Nosotros!</h2>

      {/* Formulario */}
      <FormularioContacto handleChange={handleChange} handleSubmit={handleSubmit} formData={formData} />

      {/* Detalles de áreas */}
      <div className="flex justify-center">
        <Areas />
      </div>

      {/* Mapa de Ubicación */}
      <div className="mt-10">
        <MapaUbicacion />
      </div>
    </div>
  );
}

export default Contacto;
